import { AtlassianLogo } from '@atlaskit/logo';
import { B200, B400 } from '@atlaskit/theme/colors';
import styled from '@emotion/styled';
import _ from 'lodash';
import React from 'react';
import { useSignUpFormConfig } from '../../../../../hook';
import {
  ContainerLayoutType,
  Product,
  ProductKeys
} from '../../../../../model';
import { Labels, View as SignUpFormHeader } from '../../sign-up-form-header';
import { Signup } from '../component';

export function isOpsgenieIncluded(productKeys: Product[]) {
  return _.includes(
    _.map(
      productKeys,
      (productKey: Product) => productKey.product === ProductKeys.OPSGENIE
    ),
    true
  );
}

export function LayoutStandalone(props: ContainerLayoutType) {
  const { edition } = useSignUpFormConfig();
  const formHeaderLabels = Labels.useFormHeaderLabels({
    edition: edition || '',
    labels: props.labels,
    productKeys: props.productKeys
  });
  const { userInfo, productKeys } = props;
  const opsgenieIsIncludeInProducts = isOpsgenieIncluded(productKeys);
  const isConfluence =
    (props.productKeys ?? []).filter((item) =>
      item.product.includes('confluence')
    ).length > 0;

  return (
    <StandAloneLayoutContainer className={'layout-standalone'}>
      <StandAloneLayoutInnerContainer>
        {!!userInfo && !opsgenieIsIncludeInProducts && (
          <SignUpFormHeader {...formHeaderLabels} userInfo={userInfo} />
        )}
        <RightContainerContent>
          <Signup {...props} hideGreeting={!opsgenieIsIncludeInProducts} />
        </RightContainerContent>
        {!!userInfo ||
          (!isConfluence && (
            <LogoWrapper>
              <AtlassianLogo
                textColor={B400}
                iconColor={B200}
                iconGradientStart={B400}
                iconGradientStop={B200}
                size={'xsmall'}
              />
            </LogoWrapper>
          ))}
      </StandAloneLayoutInnerContainer>
    </StandAloneLayoutContainer>
  );
}

export const StandAloneLayoutContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0px 4px 6px rgba(9, 30, 66, 0.15);
  min-height: 314px;
  padding: 0 24px;
  width: 350px;

  @media only screen and (max-width: 1023px) {
    width: 100%;
  }
`;

export const StandAloneLayoutContainerChooseSignup = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0px 4px 6px rgba(9, 30, 66, 0.15);
  width: 380px !important;
  max-width: 100%;
  min-height: 314px;
  padding: 0 30px !important;
  text-align: left !important;
`;
export const StandAloneLayoutInnerContainer = styled.div`
  margin: 32px 0;
  width: 100%;
`;

export const LogoWrapper = styled.div`
  width: min-content;
  margin: 0 auto;
`;

export const RightContainerContent = styled.div`
  margin: 16px 0;
  width: 100%;
`;
